<template>
  <div class="dialog">
    <div class='h100vh-197 w100vw-284 h-scroll'>
      <ejs-grid ref="reportGnbTaskDataRef" :allowPaging="false" :dataSource="reportDataSource" :columns='columnsOfReportData' :allowResizing='true' :height="screenHeight" :width="screenWidth" :dataBound="dataBound"  :allowExcelExport='true'></ejs-grid>
    </div>
    <div>
      <ejs-pager ref='pagerOfTaskList' @click="getReportDataListData" :currentPage='page.currentPage' :pageCount='page.pageCount' :pageSize='page.pageSize' :totalRecordsCount='page.totalRecordsCount'></ejs-pager>
    </div>
    <CustomDialog
      ref="ChartOfReportDialog"
      :element="dialog.element.ChartOfReportDialogSetting"
      :styles="dialog.element.ChartOfReportDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <ChartOfReportData ref="ChartOfReportContent"></ChartOfReportData>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import {ExcelExport} from '@syncfusion/ej2-vue-grids';
import {EventBus} from "../../../../../plugins/eventBus";
import CustomDialog from "../../../../common/CustomDialog";
import ChartOfReportData from "./dialog/ChartOfReportData";

export default {
  name: 'ReportGnbTaskList',
  components: {
    CustomDialog,
    ChartOfReportData
  },
  props: [
    'dataLength'
  ],
  provide: {
      grid: [ExcelExport]
  },
  data() {
    return {
      customs:[],
      reportDataSource: [],
      columnsOfReportData: [],
      screenHeight: 'calc(100vh - 236px)',
      screenWidth: '1462',
      page: {
        currentPage: 1,
        pageSize: 18,
        totalRecordsCount: 0,
        pageCount: 10
      },
      dialog: {
        element: {
          ChartOfReportDialogSetting: {
            styles: {
              width: "1220px",
              height: "767px",
              model: true,
              visible: false
            },
            target: "#app",
            title: this.$t("Pm.reportGnbData"),
            refName: "add",
            isClose: true,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              }
            ]
          }
        }
      },
    };
  },
  methods: {
    dialogHide() {
      this.$refs.ChartOfReportDialog.clear();
      this.$refs.ChartOfReportDialog.close();
    },
    chartOfReportShow(){
      const customsData=this.customs;
      const checkedDataList = this.getCheckedData(true);
      if (checkedDataList) {
        const checkedData = checkedDataList;
        console.log("checkedData",checkedData)
        let seriesDataMap=new Map();
        let idList=[];
        for(var i=0;i<customsData.length;i++){//表格数据
          let id=customsData[i].id;
          let text=customsData[i].text;
          let seriesData={x:[],y:[]};
          let xValueList=[];
          let yValueList=[];
          for(var j=0;j<checkedData.length;j++){//指标种类数据
            if(checkedData[j][`${id}`])//某行数据有此指标的值
            {
              xValueList.push(checkedData[j].start_time);
              yValueList.push(checkedData[j][`${id}`]);
            }
          }
          seriesData.x=xValueList
          seriesData.y=yValueList
          seriesDataMap.set(id+"+"+text,seriesData);
          idList.push(id);
        }
        this.$refs.ChartOfReportContent.initData(seriesDataMap,idList);
        this.$refs.ChartOfReportDialog.show();
      }
    },
    exportReportGnbListData() {
      const This = this;
      const checkedData = This.getCheckedData(true);
      if (checkedData) {
        const exportProperties = {
          fileName: `${this.$t('Pm.reportGnbData')}.xlsx`,
          dataSource: checkedData
        };
        This.$refs.reportGnbTaskDataRef.getColumns()[0].visible = false;
        This.$refs.reportGnbTaskDataRef.excelExport(exportProperties);
      }
    },
    getReportDataListData(){
      this.$emit('getDataByTaskId', this.$refs.pagerOfTaskList.ej2Instances.currentPage);
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.reportGnbTaskDataRef.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    dataBound() {
      let width = 820 + 300 * this.dataLength
      this.screenWidth = width < 1462 ? 1462 : width;
    },

    getColumnsOfGnbPmDataQuery(systemCheckNodeList, customCheckNodeList){
      this.customs=systemCheckNodeList;
      this.columnsOfReportData = [];

      const columnsCacheOfOrdCommonAttr = [
        {
          type:'checkbox',
          textAlign: 'Center',
          width: 44,
          autoFit: true
        },
        {
          field: 'resource_id',
          headerText: this.$t('Pm.resourceId'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'start_time',
          headerText: this.$t('Pm.startTime'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 150,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            return data[field].replace("T", " ").replace(/\+[0-9]{2}:[0-9]{2}$/g, '');
          }
        },
        {
          field: 'collect_cycle',
          headerText: this.$t('Pm.collectCycle'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true,
          valueAccessor: function valueAccessor (field,data){
            const secondCycle = parseInt(data[field]) / 60;
            if(secondCycle < 60){
              return `${secondCycle}${this.$t('Pm.minutes')}`;
            } else if(secondCycle < 1440){
                return `${secondCycle / 60}${this.$t('Pm.hours')}`;
            } else{
                return `${secondCycle / 60 / 24}${this.$t('Pm.days')}`;
            }

          }
        },
        {
          field: 'subnet_work',
          headerText: this.$t('Pm.subnetWork'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'managed_element',
          headerText: this.$t('Pm.managedElement'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 100,
          autoFit: true
        },
        {
          field: 'meas_obj_ldn',
          headerText: this.$t('Pm.measObjLdn'),
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 200,
          autoFit: true
        }
      ]

      let columnsCacheOfSystemCounter = systemCheckNodeList.map(function (checkNode) {
        return {
          field: checkNode.id,
          headerText: checkNode.text,
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 300,
          valueAccessor: function valueAccessor (field,data){
            return data[field] == undefined || data[field] == null || data[field].toString() == '' ? '—' : data[field];
          },
          autoFit: true
        }
      })

      let columnsCacheOfCustomCounter = customCheckNodeList.map(function (checkNode) {
        return {
          field: checkNode.id,
          headerText: checkNode.text,
          textAlign: 'Center',
          clipMode: 'EllipsisWithTooltip',
          width: 300,
          valueAccessor: function valueAccessor (field,data){
            return data[field] == undefined || data[field] == null || data[field].toString() == '' ? '—' : data[field];
          },
          autoFit: true
        }
      })

      for (let k = 0; k < columnsCacheOfOrdCommonAttr.length; k++) {
        this.columnsOfReportData.push(columnsCacheOfOrdCommonAttr[k]);
      }

      for (let k = 0; k < columnsCacheOfSystemCounter.length; k++) {
        this.columnsOfReportData.push(columnsCacheOfSystemCounter[k]);
      }

      for (let k = 0; k < columnsCacheOfCustomCounter.length; k++) {
        this.columnsOfReportData.push(columnsCacheOfCustomCounter[k]);
      }
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
  .dialog >>> .e-control.e-grid .e-gridcontent.e-lib.e-droppable {
    height: calc(100vh - 239px);
  }
</style>
